import React from "react";
import ButtonsList from "./ButtonsList";
import CardsContainer from "./CardsContainer";

const VideosContainer = () => {
  return (
    <div className="m-4 w-full">
      <ButtonsList />
      <CardsContainer />
    </div>
  );
};

export default VideosContainer;
